import Container from "components/sections/container";
import React from "react";
import SubResult from "./subResult";
const RESOURCES_1 = "/images/png/resources_blog1.png";

const RelatedContent = ({ data }) => {
  return (
    data && (
      <Container>
        <h1 className="font-bold text-3xl mb-4">Related Content</h1>
        <div className="flex flex-col gap-4 items-start">
          <div className="flex flex-col md:flex-row gap-4 md:justify-between justify-center w-full">
            {data?.length <= 0 ? (
              <p className="text-xl">No Related Blog </p>
            ) : (
              data?.slice(0, 2)?.map((item, index) => {
                const blogAttributes = item?.attributes?.Blogheader;
                const categoryAttributes =
                  item?.attributes?.category?.data?.attributes;
                return (
                  <div className="w-full md:w-[45%] mt-4" key={index}>
                    <SubResult
                      category={categoryAttributes?.title}
                      date={blogAttributes?.date}
                      imgSrc={
                        blogAttributes?.image?.data?.attributes.url ??
                        RESOURCES_1
                      }
                      topic={blogAttributes?.title}
                      link={`/resources/hectare/${item.attributes?.slug}`}
                    />
                  </div>
                );
              })
            )}
          </div>
        </div>
      </Container>
    )
  );
};

export default RelatedContent;
